import { CollapsibleCard, YesObject } from '@yes.technology/react-toolkit'
import { useTranslation } from 'react-i18n-lite'
import useStatusByCode from 'status/shared/hooks/useStatusByCode'
import { useFetchYesObjects } from 'yesObject/shared'
import useYesObject from 'yesObject/shared/hooks/useYesObject'
import { Line, SectionTitle, Title } from './TransportOrderCard.styles'
import CheckpointsSection from './components/CheckpointsSection/CheckpointsSection'
import RouteSection from './components/RouteSection/RouteSection'
import { Checkpoint, Route, TransportOrder } from './types'
import TaskButtons from './components/TaskButtons/TaskButtons'

type TransportOrderCardProps = TransportOrder & {
  ordersToUse?: string[]
}

function TransportOrderCard(transportOrderProps: TransportOrderCardProps) {
  const { t } = useTranslation()

  const { uuid_status: statusCode, ordersToUse } = transportOrderProps

  const { status } = useStatusByCode({
    objectclassUuid: globalThis.uuidObjectclassTransportorder,
    statusCode
  })

  const { yesObject: route } = useYesObject<Route>({
    objectUUID: transportOrderProps.route?.[0].uuid || '',
    objectclassUUID: globalThis.uuidObjectclassRoute
  })

  const { yesObjects: checkpoints }: { yesObjects: Checkpoint[] } =
    useFetchYesObjects({
      filterBody: {
        objectclass: globalThis.uuidObjectclassCheckpoint,
        query: {
          $and: [{ 'uuid.des': { $in: route?.checkpoint?.map((c) => c.uuid) } }]
        }
      },
      enabled: !!route?.checkpoint?.[0].uuid
    })

  return (
    <CollapsibleCard
      heightClass='extraSmall'
      headerColor='white'
      centerHeaderElement={<Title>{transportOrderProps.des}</Title>}
      areaLineProps={{
        flexibleHeight: true
      }}
      defaultOpenState={true}
      iconColor='#303032'
    >
      <Line />

      <TaskButtons
        status={status}
        tasks={transportOrderProps.task as YesObject[]}
      />

      <CollapsibleCard
        hierarchyCardLevel={3}
        heightClass='extraSmall'
        style={{ marginBottom: 8 }}
        areaLineProps={{
          style: { backgroundColor: '#004099' }
        }}
        centerHeaderElement={
          <SectionTitle>{t('transport-card.route')}</SectionTitle>
        }
      >
        <RouteSection route={route} checkpoints={checkpoints} />
      </CollapsibleCard>

      <CheckpointsSection checkpoints={checkpoints} ordersToUse={ordersToUse} />
    </CollapsibleCard>
  )
}

export default TransportOrderCard
